import { useState,useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { formatFullName, getDateDDMMYYYY, getDateHHMMA, getDomainValueForCode, isEmpty } from '../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../library/Service/axiosClient';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import useSmartState from '../../../common/hooks/useSmartState';
import InternalAdminReportService from '../reports/InternalAdminReportService';
import SessionContext from '../../../library/Core/SessionContext';

const GrievanceDetailPopUp = (props:any) => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);
    
    const showFlag = state?.modalFlags?.grievanceDetailPopup || false;
    const modalData = state?.modalData;
    const { setStateValue } = useSmartState();
    
    const [grievanceLogs, setGrievanceLogs] = useState([]);
    const [grievanceStatus, setGrievanceStatus] = useState('');
    const [remarks, setRemarks] = useState('');
    const [fileType, setFileType] = useState('');

    const statusOptions = [
        { value: 'inprogress', label: 'In Progress' },
        { value: 'acknowledged', label: 'Acknowledged' },
        { value: 'resolved', label: 'Resolved' },
        { value: 'discarded', label: 'Discarded' },
        { value: 'closed', label: 'Closed' },
    ];
    
    async function fetchGrievanceLogs(id: number) {
            // API call to fetch logs based on grievance id - modalData?.data?.[0].id
            const logsApiUrl = `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/grievance/get-logs/${id}`;
            // const response = await fetch(logsApiUrl); // use axiosClient
            return axiosClient().get(`${logsApiUrl}`).then((response) => {
                console.log("grievance logs response",response);
                setGrievanceLogs(response.data.data || []); // assuming response.data.data contains the logs array
            });

            // const data = await response.json();
            // console.log("grievance logs",data);
            // setGrievanceLogs(response.data);
    }
    useEffect(() => {
        const id = modalData?.data?.[0]?.id;
        if (!showFlag || !id || id <= 0) {
            return;
        }

        const getFileType = (url: string) => {
            let retVal = '';
            if (isEmpty(url)) {
                return retVal;
            } else {
                retVal = 'doc'
            }

            const imgArray = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
            const extension = url.split('.').at(-1);

            if (extension && imgArray.includes(extension.toLowerCase())) {
                retVal = 'img';
            }

            return retVal;
        }
        setFileType(getFileType(modalData?.data?.[0]?.file))

        // fetch grievance logs
        fetchGrievanceLogs(id);

    }, [modalData?.data?.[0]?.id, showFlag])

    const updateGrievanceStatus = async() => {
        if(isEmpty(grievanceStatus)){
            Swal.fire({
                icon: 'warning',
                title: 'Please select a status to update',
            });
            return;
        }

        if (remarksRequiredStatuses.includes(grievanceStatus) && isEmpty(remarks)) {
            Swal.fire({
                icon: 'warning',
                title: 'Remarks Required',
                text: 'Please provide remarks for the selected status.',
            });
            return;
        }

        // show confirmation popup before updating the status
        const confirmation = await Swal.fire({
            icon: 'question',
            title: 'Are you sure?',
            text: 'Do you want to update the grievance status?',
            showCancelButton: true,
            confirmButtonText: 'Yes, Proceed!',
            cancelButtonText: 'No',
        });
        if (!confirmation.isConfirmed) {
            return;
        }
        const updateApiUrl = `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/grievance/update-status`;
        const payload = {
            id: modalData?.data?.[0].id,
            status: grievanceStatus,
            remarks: remarks
        }
        axiosClient().post(`${updateApiUrl}`, payload).then((response) => {
            console.log("update status response",response);
            if(response.data.success){
                // Swal.fire({
                //     icon: 'success',
                //     title: 'Grievance status updated successfully',
                // }).then(() => {
                //     // refresh logs after status update
                //     fetchGrievanceLogs(modalData?.data?.[0].id);
                // });
                InternalAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                    fetchGrievanceLogs(modalData?.data?.[0].id);
                    setStateValue('alumniList', response.data);
                    setRemarks('');
                    setGrievanceStatus('')
                    dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'grievanceDetailPopup' } });
                    toast.success(`${response.data.message || 'Grievance status updated successfully!'}`);
                });
                
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to update grievance status',
                    text: response.data.message || 'An error occurred while updating the status. Please try again.',
                });
            }
        }).catch((error) => {
            console.error("Error updating grievance status", error);
            Swal.fire({
                icon: 'error',
                title: 'Failed to update grievance status',
                text: error.message || 'An error occurred while updating the status. Please try again.',
            });
        });
    }
    const getGrievanceHMLField = (key: any, value: any) => {
        // const value = row[control.id];
        let displayValue = value;
        // if (control.props?.domainCategoryCode?.length > 0)
        //     displayValue = getDomainValueForCode(row[control.id], control.props.domainCategoryCode, state);
        let content;
        let domainCategoryCode = '';
        switch (key) {
            case 'grievancePriority':
                domainCategoryCode = 'GRIEVANCE_PRIORITY';
                break;
            case 'grievanceStatus':
                domainCategoryCode = 'GRIEVANCE_STATUS';
                break;
            case 'mode':
                domainCategoryCode = 'GRIEVANCE_COMMUNICATION_MODE';
                break;
            default:
                return value;
        }
        
        if ( ! isEmpty(domainCategoryCode) && !isEmpty(value)) {
            displayValue = getDomainValueForCode(value, domainCategoryCode, state);
        }

        const getColorClasses = (value: string) => {
            if (!value) {
                return ['#e5e7eb', '#6b7280'];
            }
            switch (value.toLowerCase()) {
                // Priority Colors
                case 'high':
                    return ['#fee2e2', '#dc2626'];
                case 'medium':
                    return ['#fed7aa', '#ea580c'];
                case 'low':
                    return ['#e5e7eb', '#6b7280'];

                // Status Colors
                case 'new':
                    return ['#cff4fc', '#2680EB'];
                case 'acknowledged':
                    return ['#fef3c7', '#d97706'];
                case 'inprogress':
                    return ['#cffafe', '#0891b2'];
                case 'resolved':
                    return ['#d1fae5', '#059669'];
                case 'discarded':
                case 'closed':
                    return ['#e5e7eb', '#6b7280'];

                default:
                    return ['#e5e7eb', '#6b7280'];
            }
        }
        const [bgColor, textColor] = getColorClasses(value);

        content = (
            <span className={`badge rounded-pill bg-opacity-50 font-14 font-500 px-3 py-2 max-80 w-auto`} style={{ backgroundColor: bgColor, color: textColor }}>
                {displayValue}
            </span>
        );
        return content;
    }
    
    const notAllowedStatuses = ['resolved', 'discarded', 'closed'];
    const remarksRequiredStatuses = ['resolved', 'discarded', 'closed'];
    
    return (
       <div
            id="update-subject-marks"
            className={`modal fade ${showFlag ? 'show' : ''}`} // removed vh-100 and show class
            tabIndex={-1}
            role="dialog"
            style={{ display: showFlag ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
        
        <div className="modal-dialog modal-dialog-centered max-600 mx-auto">
            <div className="modal-content radius-15">
            
                <div className="modal-body p-4 p-md-5">

                    <h5 className="font-30 font-600 mb-0" id="staticBackdropLabel">{modalData?.title}</h5>
                    <p className="font-24 font-500 mb-4 text-secondary">{modalData?.data?.[0]?.grievanceCode}</p>
                    
                    <button
                        type="button"
                        className="btn-close btn-close-small"
                        onClick={() => {
                            setGrievanceStatus('');
                            setRemarks('');
                            dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'grievanceDetailPopup' } });
                        }}
                        aria-label="Close"></button>
                    
                    <div className="row g-4">
                        <div className="col-md-12">
                        <div className="bg-gray-f5 px-4 py-3 rounded">
                            <div className="row g-3 g-2 align-items-center justify-content-between">
                                <div className="col-auto">
                                    <p className="font-18 font-500 mb-0">
                                        Current Status {getGrievanceHMLField('grievanceStatus', modalData?.data?.[0]?.grievanceStatus)}
                                    </p>
                                </div>
                                <div className="col-auto">
                                    <p className="font-18 font-500 mb-0">
                                        Priority {getGrievanceHMLField('grievancePriority', modalData?.data?.[0]?.grievancePriority)}
                                    </p>
                                </div>
                            </div>
                        </div>
                        </div>

                        <div className="col-md-12">
                        <label className="form-label font-20 mb-1">Alumni Information</label>
                        <div className="bg-gray-f5 px-4 py-3 rounded">
                            <div className="row g-3 g-2 align-items-center justify-content-between">
                            <div className="col-sm-3 col-6">
                                <span className="font-16">Name</span>
                                <p className="font-16 font-500 mb-0">{formatFullName(modalData?.data?.[0]?.grievanceUserName, "")}</p>
                            </div>
                            <div className="col-sm-3 col-6">
                                <span className="font-16">Program</span>
                                <p className="font-16 font-500 mb-0">{modalData?.data?.[0]?.grievanceUserProgram ?? "Not Available"}</p>
                            </div>
                            <div className="col-sm-3 col-6">
                                <span className="font-16">Batch Year</span>
                                <p className="font-16 font-500 mb-0">{modalData?.data?.[0]?.grievanceUserBatch ?? "Not Available"}</p>
                            </div>
                            <div className="col-sm-3 col-6">
                                <span className="font-16">Profile Status</span>
                                <p className="badge rounded-pill bg-opacity-50 font-14 font-500 px-3-removed py-2 max-100 w-auto" style={{backgroundColor: `${modalData?.data?.[0]?.leadType === 'system' ? '#28a745' : '#808080'}`}}>{modalData?.data?.[0]?.leadType === 'system' ? '☑ Profile Linked' : 'Not Linked'}</p>
                            </div>
                            </div>
                        </div>
                        </div>

                        <div className="col-md-12">
                        <label className="form-label font-20 mb-1">Grievance Details</label>
                        <div className="bg-gray-f5 px-4 py-3 rounded">
                            <div className="row g-3 g-2 align-items-center justify-content-between">
                            <div className="col-sm-6 col-6">
                                <span className="font-16">Grievance Type</span>
                                <p className="font-16 font-500 mb-0">{getDomainValueForCode(modalData?.data?.[0]?.grievanceCategory, 'GRIEVANCE_CATEGORY', state)}</p>
                            </div>
                            <div className="col-sm-6 col-6">
                                <span className="font-16">Mode of Communication</span>
                                <p className="font-16 font-500 mb-0">{getDomainValueForCode(modalData?.data?.[0]?.mode, 'GRIEVANCE_COMMUNICATION_MODE', state)}</p>
                            </div>
                            <div className="col-sm-6 col-6">
                                <span className="font-16">Created on</span>
                                <p className="font-16 font-500 mb-0">{getDateDDMMYYYY(modalData?.data?.[0]?.createdAtDdMmYyyy)}</p>
                            </div>
                            <div className="col-sm-6 col-6">
                                <span className="font-16">Last Updated</span>
                                <p className="font-16 font-500 mb-0">{getDateDDMMYYYY(modalData?.data?.[0]?.updatedAtDdMmYyyy)}</p>
                            </div>
                            <div className="col-12">
                                <label className="font-16 font-400">Description</label>
                                <div className="bg-white px-4 py-3 rounded rich-text-content">
                                <p className="mb-0" style={{ whiteSpace: "break-spaces" }} dangerouslySetInnerHTML={{ __html: modalData?.data?.[0]?.description }} />
                                </div>
                            </div>
                            {fileType && !isEmpty(modalData.data?.[0]?.file) && (
                                <div className="col-12">
                                    <label className="font-16 font-400">Attachment</label>
                                    <div className="bg-white px-4 py-3 rounded">
                                    {fileType == 'img' && <img src={modalData.data?.[0]?.file} width="160" alt="" className="img-fluid" />}
                                    {fileType == 'doc' && <a href={modalData.data?.[0]?.file} target='_blank' rel="noopener noreferrer">View File</a>}
                                    </div>
                                </div>
                            )}
                            
                            </div>
                        </div>
                        </div>

                        {!notAllowedStatuses.includes(modalData?.data?.[0]?.grievanceStatus) && (
                            <div className="col-md-12">
                                {/* <label className="form-label font-20 mb-2 d-block">Update Status</label> */}
                                <label className="form-label">Change Status</label>
                                <select id='grievanceStatus' onChange={(e) => setGrievanceStatus(e.target.value)} className="form-select" aria-label="Default select example"  value={grievanceStatus}>
                                    <option value="" selected={true}>Select Status</option>
                                    {statusOptions.map((option) => (
                                        option.value !== modalData?.data?.[0]?.grievanceStatus && (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                        )
                                    ))}
                                </select>
                            </div>
                        )}
                        {/* Conditionally show Remarks textarea */}
                        {!notAllowedStatuses.includes(modalData?.data?.[0]?.grievanceStatus) && remarksRequiredStatuses.includes(grievanceStatus) && (
                            <div className="col-md-12">
                                <label className="form-label">Remarks</label>
                                <textarea
                                    id="remarks"
                                    onChange={(e) => setRemarks(e.target.value)}
                                    className="form-control"
                                    placeholder="Enter remarks"
                                    rows={3}
                                />
                            </div>
                        )}

                        <div className="col-md-12">
                            <label className="form-label fs-5 fw-semibold mb-4 d-block">Activity Timeline</label>

                            {grievanceLogs.map((log: any, index: number) => (
                                <div key={index} className="d-flex align-items-stretch">

                                {/* Date — vertically centered to match dot */}
                                <div
                                    className="text-end pe-3 flex-shrink-0 d-flex align-items-center justify-content-end"
                                    style={{ minWidth: '90px' }}
                                >
                                    <span className="text-muted" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
                                    {getDateDDMMYYYY(log?.createdAtDdMmYyyy)} <br />
                                    {getDateHHMMA(log?.createdAtDdMmYyyy)}
                                    </span>
                                </div>

                                {/* Spine: top-line + dot + bottom-line */}
                                <div className="d-flex flex-column align-items-center flex-shrink-0" style={{ width: '24px' }}>
                                    <div style={{ width: '2px', flex: 1, background: index === 0 ? 'transparent' : '#dee2e6' }} />
                                    <div
                                    className="rounded-circle bg-primary flex-shrink-0"
                                    style={{
                                        width: '14px',
                                        height: '14px',
                                        border: '3px solid var(--bs-body-bg)',
                                        outline: '1.5px solid #b5d4f4',
                                    }}
                                    />
                                    <div style={{ width: '2px', flex: 1, background: index === grievanceLogs.length - 1 ? 'transparent' : '#dee2e6' }} />
                                </div>

                                {/* Content card */}
                                <div className="flex-grow-1 ps-3 py-2 d-flex align-items-center" style={{ paddingBottom: index === grievanceLogs.length - 1 ? '0' : '16px' }}>
                                    <div className="card border shadow-none w-100">
                                        <div className="card-body py-3 px-3">
                                            <div className="row g-3">
                                                <div className="col-sm-6">
                                                    <span className="d-block text-muted mb-1" style={{ fontSize: '12px' }}>Status</span>
                                                    {/* <span className="badge rounded-pill text-bg-primary fw-normal px-3 py-2" style={{ fontSize: '13px' }}> */}
                                                    {/* {getDomainValueForCode(log?.status, 'GRIEVANCE_STATUS', state)} */}
                                                    {getGrievanceHMLField('grievanceStatus', log?.status)}
                                                    {/* </span> */}
                                                </div>
                                                <div className="col-sm-6">
                                                    <span className="d-block text-muted mb-1" style={{ fontSize: '12px' }}>Performed by</span>
                                                    <p className="fw-semibold mb-0">
                                                    {log?.createdByRole === 'SUPER_ADMIN' && sessionState?.userTypeCode != 'SUPER_ADMIN' ? 'Servicing Team' : log?.createdBy || 'System'}
                                                    </p>
                                                </div>
                                            </div>

                                            {remarksRequiredStatuses.includes(log?.status) && (
                                                <div className="row g-3 mt-2">
                                                    <div className="col-12">
                                                        <span className="d-block text-muted mb-1" style={{ fontSize: '12px' }}>Remarks</span>
                                                        <p className="mb-0" style={{ whiteSpace: "break-spaces" }} dangerouslySetInnerHTML={{ __html: log?.remarks || 'No remarks provided.' }} />
                                                    </div>
                                                </div>
                                            )}
                                            
                                        </div>
                                    </div>
                                </div>

                                </div>
                            ))}
                            {/* No data available */}
                            {grievanceLogs.length === 0 && (
                                <div className="text-center text-muted py-4">
                                    <p className="mb-0">No activity data available.</p>
                                </div>
                            )}
                            </div>

                        <div className="col-12 sticky-actions">
                        <div className="row g-2 justify-content-center align-items-center">
                            {/* <div className="col-auto"><button type="button" className="btn btn-border-gray height-40" data-bs-dismiss="modal"><span>Cancel</span></button></div>
                            <div className="col-auto"><button type="submit" className="btn btn-dark-blue max-135 text-white height-40" data-bs-toggle="modal" data-bs-target="#select-user-popup" data-bs-dismiss="modal"><span>Save Changes</span></button></div> */}
                            <div className="col-auto">
                                <button type="button" className="btn btn-border-gray height-40" 
                                    onClick={() => {
                                        setGrievanceStatus('');
                                        setRemarks('');
                                        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'grievanceDetailPopup' } });
                                    }}>
                                    <span>Close</span>
                                </button>
                            </div>
                            
                            {!notAllowedStatuses.includes(modalData?.data?.[0]?.grievanceStatus) && (
                            <div className="col-auto">
                                <button type="submit" className="btn btn-dark-blue max-135 text-white height-40"
                                    onClick={() => updateGrievanceStatus()}>
                                    <span>Save Changes</span>
                                </button>
                            </div>
                            )}
                        </div>
                        </div>              
                
                    </div>  
                    
                </div>
            </div>
        </div>
      </div>
    );
};  

export default GrievanceDetailPopUp;